import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useForm } from "react-hook-form";
import ProfilePicture from "../../Presentational/Person/ProfilePicture/ProfilePicture";
import ValidationService from "../../../Services/Shared/Validation.service";
import useService from "../../Hooks/useService";
import PersonService from "../../../Services/Person.service";
import { SaveButton } from "../StandardButtons/StandardButtons";
const ReplyBox = (props) => {
    const [me, loadMe] = useService(PersonService.me);
    React.useEffect(() => {
        loadMe();
    }, [loadMe]);
    const [makeCommentState, makeComment] = useService(props.onMakeComment);
    const { register, errors, handleSubmit, reset } = useForm();
    // @ts-expect-error - TS7031 - Binding element 'commentBody' implicitly has an 'any' type.
    const submit = ({ commentBody }) => {
        makeComment(commentBody).then(() => {
            reset();
        });
    };
    return (_jsxs("div", { className: "d-flex justify-content-between " + (props.className || ""), children: [me.data && (_jsx(ProfilePicture, { person: me.data, showProfilePicture: true, size: 30, className: "mr-2" })), _jsxs("form", { onSubmit: handleSubmit(submit), className: "d-flex flex-grow-1", children: [_jsxs("div", { className: "flex-grow-1", children: [_jsx("input", { type: "text", className: ValidationService.makeClassName(errors, "commentBody", "form-control"), ref: register({ required: "Comment is required" }), name: "commentBody", autoFocus: true, autoComplete: "off" }), _jsx("div", { className: "invalid-feedback", children: "Please enter a comment" })] }), _jsx(SaveButton, { isLoading: makeCommentState.isLoading, type: "submit", className: "ml-2" })] })] }));
};
export default ReplyBox;
